// extracted by mini-css-extract-plugin
module.exports = {"batteryExpandability":"BatteryExpandability_batteryExpandability__LRS9L","ef-box":"BatteryExpandability_ef-box__mbPdQ"};